import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageApiInterceptorService } from './interceptors/language-api-interceptor.service';

@NgModule({
  imports: [CommonModule],
  providers: [LanguageApiInterceptorService],
})
export class SharedDataAccessApiI18nModule {}
